import * as ASSET_TYPES from '../constants/assetTypes';

export default {
  [ASSET_TYPES.IMAGES]: {
    blocks: {
      tile: 'dia1.png',
      block: 'dia2.png',
      blockTall: 'dia3.png',
      blockShort: 'dia4.png',
      tree: 'tree.png',
    },
    ui: {
      cursor: 'cursor.png',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/assets.js